/**
 * Admin "login as" faol bo'lganda — eski akkauntga qaytish.
 */

import React, { useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../../contexts/LanguageContext';
import { useAuth, normalizeUser } from '../../auth/authContext';
import { getProfile, setStoredTokens } from '../../services/authApi';
import {
  clearAdminImpersonationBackup,
  isAdminImpersonationActive,
  readAdminImpersonationBackup,
} from '../../utils/adminImpersonationStorage';
import { getDefaultPathForRole } from '../../config/sidebar';
import type { Role } from '../../config/roles';
import type { User } from '../../auth/authContext';
import './ImpersonationBanner.css';

export function ImpersonationBanner() {
  const { t } = useLanguage();
  const { setUser } = useAuth();
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');

  const active = isAdminImpersonationActive();

  const handleExit = useCallback(async () => {
    const backup = readAdminImpersonationBackup();
    if (!backup) return;
    setErr('');
    setBusy(true);
    try {
      setStoredTokens({
        accessToken: backup.accessToken,
        refreshToken: backup.refreshToken,
      });
      clearAdminImpersonationBackup();
      let u: User | null = null;
      try {
        u = JSON.parse(backup.userSnapshot) as User;
      } catch {
        u = null;
      }
      if (u?.role) {
        setUser(u);
      }
      const prof = await getProfile().catch(() => null);
      if (prof) {
        setUser(normalizeUser(prof as Parameters<typeof normalizeUser>[0]));
      }
      const role = (u?.role ?? 'platform_owner') as Role;
      navigate(`/admin/${getDefaultPathForRole(role)}`, { replace: true });
    } catch (e: unknown) {
      setErr((e as Error)?.message ?? t('adminImpersonate_exit_error'));
    } finally {
      setBusy(false);
    }
  }, [setUser, navigate, t]);

  if (!active) return null;

  return (
    <div className="admin-imp-banner" role="status">
      <span className="admin-imp-banner-text">{t('adminImpersonate_banner')}</span>
      {err ? <span className="admin-imp-banner-err">{err}</span> : null}
      <button type="button" className="admin-imp-banner-btn" onClick={handleExit} disabled={busy}>
        {busy ? t('loginModalChecking') : t('adminImpersonate_exit')}
      </button>
    </div>
  );
}
